/**
 * fancybox-эффект в шаблоне статьи для изображений в контенте
 */

const check_valid_file_extension = (element) => {
    return /\.(jpe?g|png|gif)$/i.test($(element).attr('href'));
};

const is_not_gallery_images = (element) => {
    return ! $(element).parents('.glide--slider').length;
};

const fancyboxEffects = () => {
    const fancybox_options = {
        'touch': false
    };

    // Donation forms
    if ($('a[data-rel="fancybox-donation-form"]').length) {
        import('@fancyapps/fancybox').then(fancybox => {
            $('a[data-rel="fancybox-donation-form"]').fancybox(fancybox_options);
            import('@fancyapps/fancybox/dist/jquery.fancybox.css');
        });
    }

    // Fond donation button
    if ($('.js-embedded-fond-donation-button').length) {
        import('@fancyapps/fancybox').then(fancybox => {
            import('@fancyapps/fancybox/dist/jquery.fancybox.css');
        });
    }

    // Copy the title of every IMG tag and add it to its parent A so that fancybox can show titles
    $.fn.setFancyboxTitle = function() {

        return this.each(function() {
            var fancy_title = '';

            var title = $(this).children('img').attr('title');

            if (title) {
                fancy_title = title;
            } else {
                fancy_title = $(this).children('img').attr('alt'); // alt attribute
            }

            $(this).attr('data-caption', fancy_title);
        });
    };

    var $content_blocks = $('.hh-post-content');
    var $thumbnails = $content_blocks.find('a:has(img)')
        .filter((i, element) => {
            return check_valid_file_extension(element) && is_not_gallery_images(element);
        });

    if ($thumbnails.length) {
        import('@fancyapps/fancybox').then(fancybox => {
            import('@fancyapps/fancybox/dist/jquery.fancybox.css');

            $thumbnails
                .attr('data-rel', 'fancybox-image')
                .setFancyboxTitle()
                .attr('data-fancybox', 'post-images');

            $thumbnails.fancybox(fancybox_options);
        });
    }

    // Страница Реклама
    if ($('.js-reklama-page-video').length) {
        import('@fancyapps/fancybox').then(fancybox => {
            import('@fancyapps/fancybox/dist/jquery.fancybox.css');

            const options = {
                maxWidth	: 800,
                maxHeight	: 600,
                fitToView	: false,
                width		: '70%',
                height		: '70%',
                autoSize	: false,
                closeClick	: false,
                openEffect	: 'elastic',
                closeEffect	: 'none',
            };

            $(".js-reklama-page-video").fancybox(options);

        });
    }
};

export default fancyboxEffects;